import { OwnProfile } from '@/components/dashboard/OwnProfile';

export function ProfilePage() {
  return <OwnProfile platform />;
}
